import Strike from '@tiptap/extension-strike';

/**
 * Change the tag from <s> to <strike>
 */
export default Strike.extend({
  renderHTML({ HTMLAttributes }: { HTMLAttributes: Record<string, any> }) {
    return ['strike', HTMLAttributes];
  },

  parseHTML() {
    return [
      { tag: 'strike' },
    ];
  },
});
